<template>
  <motlet :options="motletOptions">
    <template v-slot:content>
      <v-card class="scroll" :max-height="params.height" flat>{{ value }}</v-card>
    </template>
  </motlet>
</template>

<script>
import bus from '../../../../../utils/bus';

export default {
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      motletOptions: {
        id: 'detailview/java/javaLog/logMessage',
        title: 'Message',
      },
      value: '',
    };
  },
  methods: {
    fetch(data) {
      this.value = (data || {}).msg;
    },
  },
  created() {
    bus.$on('select:log', this.fetch);
  },
  destroyed() {
    bus.$off('select:log');
  },
};
</script>

<style scoped>
.scroll {
  overflow: auto;
}
</style>
